import axios from 'axios';

const baseUrl = id => `/api/v1/wire/${id}/restrictions`;

export function getEventRestrictions(id) {
  return axios.get(baseUrl(id), { cache: { ignoreCache: true } });
}

export function updateEventRestrictions(wireId, eventId) {
  return axios.post(`${baseUrl(wireId)}/_update_restricted_to_event_id`, {
    restricted_to_event_id: eventId,
  });
}

export function updateRegUserRestrictions(id, isRestricted) {
  return axios.post(`${baseUrl(id)}/_update_is_restricted_to_registered_users`, {
    is_restricted_to_registered_users: isRestricted,
  });
}

export function updateRedirectionUrl(id, url) {
  return axios.post(`${baseUrl(id)}/_update_restricted_to_registered_users_redirect_url`, {
    restricted_to_registered_users_redirect_url: url,
  });
}
